import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	NoConditions: {
		k: "conditions.none",
		v: "No Conditions"
	}
});



// WEBPACK FOOTER //
// ./src/panels/conditionProgress/ConditionProgress.labels.tsx